var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticStyle:{"height":"100%"}},[(_vm.$route.query.src)?_c('iframe',{ref:"iframe",staticClass:"iframe",attrs:{"id":"iframeId","src":_vm.iframeSrc}}):_c('iframe',{ref:"iframe",staticClass:"iframe",attrs:{"src":_vm.urlPath,"id":"iframeId"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }